/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Flow Do API
 * API таск-менеджера Flow Do. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorModel,
  StatusBody
} from '../model';

import { apiFetch } from '../../http';

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type healthLiveResponse200 = {
  data: StatusBody
  status: 200
}

export type healthLiveResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 200>
}

export type healthLiveResponseSuccess = (healthLiveResponse200) & {
  headers: Headers;
};
export type healthLiveResponseError = (healthLiveResponseDefault) & {
  headers: Headers;
};

export type healthLiveResponse = (healthLiveResponseSuccess | healthLiveResponseError)

export const getHealthLiveUrl = () => {




  return `/health`
}

/**
 * Отвечает, пока процесс жив. К базе данных не обращается, поэтому годится как liveness-проба: перезапускать контейнер из-за недоступной базы не нужно.
 * @summary Живость сервиса
 */
export const healthLive = async ( options?: Parameters<typeof apiFetch>[1]): Promise<healthLiveResponse> => {

  return apiFetch<healthLiveResponse>(getHealthLiveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthLiveQueryKey = () => {
    return [
    `/health`
    ] as const;
    }


export const getHealthLiveQueryOptions = <TData = Awaited<ReturnType<typeof healthLive>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthLive>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthLiveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthLive>>> = ({ signal }) => healthLive({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthLive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthLiveQueryResult = NonNullable<Awaited<ReturnType<typeof healthLive>>>
export type HealthLiveQueryError = ErrorModel


export function useHealthLive<TData = Awaited<ReturnType<typeof healthLive>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthLive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthLive>>,
          TError,
          Awaited<ReturnType<typeof healthLive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthLive<TData = Awaited<ReturnType<typeof healthLive>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthLive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthLive>>,
          TError,
          Awaited<ReturnType<typeof healthLive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthLive<TData = Awaited<ReturnType<typeof healthLive>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthLive>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Живость сервиса
 */

export function useHealthLive<TData = Awaited<ReturnType<typeof healthLive>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthLive>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthLiveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type healthReadyResponse200 = {
  data: StatusBody
  status: 200
}

export type healthReadyResponse500 = {
  data: ErrorModel
  status: 500
}

export type healthReadyResponse503 = {
  data: ErrorModel
  status: 503
}

export type healthReadyResponseSuccess = (healthReadyResponse200) & {
  headers: Headers;
};
export type healthReadyResponseError = (healthReadyResponse500 | healthReadyResponse503) & {
  headers: Headers;
};

export type healthReadyResponse = (healthReadyResponseSuccess | healthReadyResponseError)

export const getHealthReadyUrl = () => {




  return `/health/ready`
}

/**
 * Проверяет, отвечает ли база данных. Отдаёт 503, если сервис поднят, но обслуживать запросы не может, — это readiness-проба.
 * @summary Готовность сервиса
 */
export const healthReady = async ( options?: Parameters<typeof apiFetch>[1]): Promise<healthReadyResponse> => {

  return apiFetch<healthReadyResponse>(getHealthReadyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthReadyQueryKey = () => {
    return [
    `/health/ready`
    ] as const;
    }


export const getHealthReadyQueryOptions = <TData = Awaited<ReturnType<typeof healthReady>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthReady>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthReadyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthReady>>> = ({ signal }) => healthReady({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthReady>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthReadyQueryResult = NonNullable<Awaited<ReturnType<typeof healthReady>>>
export type HealthReadyQueryError = ErrorModel


export function useHealthReady<TData = Awaited<ReturnType<typeof healthReady>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthReady>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthReady>>,
          TError,
          Awaited<ReturnType<typeof healthReady>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthReady<TData = Awaited<ReturnType<typeof healthReady>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthReady>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthReady>>,
          TError,
          Awaited<ReturnType<typeof healthReady>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthReady<TData = Awaited<ReturnType<typeof healthReady>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthReady>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Готовность сервиса
 */

export function useHealthReady<TData = Awaited<ReturnType<typeof healthReady>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthReady>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthReadyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






